import React, {Component} from 'react';
import { Link, withRouter } from 'react-router-dom';
import {
  Step,
  Stepper,
  StepButton,
  StepLabel
} from 'material-ui/Stepper';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import ArrowForwardIcon from 'material-ui/svg-icons/navigation/arrow-forward';
import Validator from '../../../lib/validator';
import { connect } from 'react-redux';
import hour from '../../../lib/hour'
import parseUrl from '../../../lib/parseurl'
import { moneyFormat } from '../../../lib/iuran'
// import this library to clear local storage function 
import { ClearLocalStorageAll, ClearLocalStorageStep2, ClearLocalStorageStep1 } from '../../../lib/clearLocalStorage'

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import citilinkTheme from '../../../lib/bpjs-theme';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

import Modal from 'react-bootstrap/lib/Modal';
import ProvinsiDropdown from '../../AddressDropdown/ProvinsiDropdown'
import KotaDropdown from '../../AddressDropdown/KotaDropdown'
import KantorCabangDropdown from '../../AddressDropdown/KantorCabangDropdown'

import { verifyKTP, register, hitungIuran, prosesKodeIuran } from '../../../bpjs-api/api'
import WarningIcon from 'material-ui/svg-icons/alert/warning';
import {red500} from 'material-ui/styles/colors';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import Loading from '../../Loading'
import Pembayaran from '../../Pembayaran/pembayaran'

let program = [];

class Content extends Component {

  constructor(props) {
    super(props);
    // console.log(`this props content`, this.props)
    this.state = {
      stepIndex: ((localStorage.getItem("step_status") !== null) ? Number(localStorage.getItem("step_status")) : 0),
      modalStyle: {
        display: 'none',
        height: '100vh'
      },
      paymentOptionsStep: false,
      modalPenjelasan: {
        display: 'none',
      },
      modalPembayaran: {
        display: 'none',
      },
      data_step_1: {
        // change state when refresh evrything should blank string
        // Email: '' ,
        // NoPonsel: '',
        // Alamat: '',
        // before
        // Email: ((localStorage.getItem("Email") !== null) ? localStorage.getItem("Email") : ''),
        // NoPonsel: ((localStorage.getItem("NoPonsel") !== null) ? localStorage.getItem("NoPonsel") : ''),
        Alamat: ((localStorage.getItem("Alamat") !== null) ? localStorage.getItem("Alamat") : ''),
        Email: ((localStorage.getItem("step_status") === '2' || localStorage.getItem("step_status") === '1' ) ? localStorage.getItem("Email") : ''),
        NoPonsel: ((localStorage.getItem("step_status") === '2' || localStorage.getItem("step_status") === '1') ? localStorage.getItem("NoPonsel") : ''),
        // Alamat: ((localStorage.getItem("step_status") === '2' || localStorage.getItem("step_status") === '1' || localStorage.getItem("step_status") === '0') ? localStorage.getItem("Alamat") : ''),
      },
      data_step_2: {
        // change state to blank when refresh
        // Provinsi: '',
        // Kota: '',
        // Cabang: '',
        // Pekerjaan: '',
        // Gaji: '',
        // JamMasukKantor: '',
        // JamKeluarKantor: '',
        // PeriodeProgram: '',
        // NoVerifikasiSMS: ''
        // Provinsi: ((localStorage.getItem("Provinsi") !== null) ? localStorage.getItem("Provinsi") : ''),
        // Kota: ((localStorage.getItem("Kota") !== null) ? localStorage.getItem("Kota") : ''),
        // Cabang: ((localStorage.getItem("Cabang") !== null) ? localStorage.getItem("Cabang") : ''),
        // Pekerjaan: ((localStorage.getItem("Pekerjaan") !== null) ? localStorage.getItem("Pekerjaan") : ''),
        // Gaji: ((localStorage.getItem("Gaji") !== null) ? localStorage.getItem("Gaji") : ''),
        // JamMasukKantor: ((localStorage.getItem("JamMasukKantor") !== null) ? localStorage.getItem("JamMasukKantor") : ''),
        // JamKeluarKantor: ((localStorage.getItem("JamKeluarKantor") !== null) ? localStorage.getItem("JamKeluarKantor") : ''),
        // Program: ((localStorage.getItem("Program") !== null) ? localStorage.getItem("Program") : ''),
        // PeriodeProgram: ((localStorage.getItem("PeriodeProgram") !== null) ? localStorage.getItem("PeriodeProgram") : ''),
        // NoVerifikasiSMS: ((localStorage.getItem("NoVerifikasiSMS") !== null) ? localStorage.getItem("NoVerifikasiSMS") : ''),
        Provinsi: ((localStorage.getItem("step_status") === '2') ? localStorage.getItem("Provinsi") : ''),
        Kota: ((localStorage.getItem("step_status") === '2') ? localStorage.getItem("Kota") : ''),
        Cabang: ((localStorage.getItem("step_status") === '2') ? localStorage.getItem("Cabang") : ''),
        Pekerjaan: ((localStorage.getItem("step_status") === '2') ? localStorage.getItem("Pekerjaan") : ''),
        Gaji: ((localStorage.getItem("step_status") === '2') ? localStorage.getItem("Gaji") : ''),
        JamMasukKantor: ((localStorage.getItem("step_status") === '2') ? localStorage.getItem("JamMasukKantor") : ''),
        JamKeluarKantor: ((localStorage.getItem("step_status") === '2') ? localStorage.getItem("JamKeluarKantor") : ''),
        Program: ((localStorage.getItem("step_status") === '2') ? localStorage.getItem("Program") : ''),
        PeriodeProgram: ((localStorage.getItem("step_status") === '2') ? localStorage.getItem("PeriodeProgram") : ''),
        NoVerifikasiSMS: ((localStorage.getItem("step_status") === '2') ? localStorage.getItem("NoVerifikasiSMS") : ''),
      },
      errorValidator_step_1: {
        errorEmail: false,
        errorNoPonsel: false,
        errorAlamat: false,
        // state for validator made by alfan
        errorEmailMessage: null,
        errorNoPonselMessage: null
      },
      errorValidator_step_2: {
        errorProvinsi: false,
        errorKota: false,
        errorCabang: false,
        errorPekerjaan: false,
        errorGaji: false,
        errorJamMasukKantor: false,
        errorJamKeluarKantor: false,
        errorProgram: false,
        errorPeriodeProgram: false,
        errorNoVerifikasiSMS: false,
        // state for validator made by alfan
        errorPekerjaanMessage: null,
        errorGajiMessage: null,
        errorNoVerifikasiSMSMessage: null,
        errorJamKantor: false,
        errorJamKantorMessage: null,
      },
      tampilkanPerhitunganIuran: 'none',
      data_diri_style: {
        NIKLabelShow: 'block',
        NIKInputShow: 'none',
        NamaLabelShow: 'block',
        NamaInputShow: 'none',
        TglLahirLabelShow: 'block',
        TglLahirInputShow: 'none',
        EmailLabelShow: 'block',
        EmailInputShow: 'none',
        NoTlpLabelShow: 'block',
        NoTlpInputShow: 'none',
        AlamatLabelShow: 'block',
        AlamatInputShow: 'none',
        ProvinsiLabelShow: 'block',
        ProvinsiInputShow: 'none',
        KotaLabelShow: 'block',
        KotaInputShow: 'none',
        CabangLabelShow: 'block',
        CabangInputShow: 'none',
        PekerjaanLabelShow: 'block',
        PekerjaanInputShow: 'none',
        GajiLabelShow: 'block',
        GajiInputShow: 'none',
        JamMasukKantorLabelShow: 'block',
        JamMasukKantorInputShow: 'none',
        PeriodeProgramLabelShow: 'block',
        PeriodeProgramInputShow: 'none',
        NoVerifikasiSMSLabelShow: 'block',
        NoVerifikasiSMSInputShow: 'none',
        // add by alfan
        ProgramLabelShow: 'block',
        ProgramInputShow: 'none'
      },
      data: {
        // NIK: '',
        // NamaLengkap: '',
        // ThnLahir: '',
        // BlnLahir: '',
        // TglLahir: '',
        NIK: ((localStorage.getItem("step_status") !== null) ? localStorage.getItem("NIK") : ''),
        NamaLengkap: ((localStorage.getItem("step_status") !== null) ? localStorage.getItem("NamaLengkap") : ''),
        ThnLahir: ((localStorage.getItem("step_status") !== null) ? localStorage.getItem("ThnLahir") : ''),
        BlnLahir: ((localStorage.getItem("step_status") !== null) ? localStorage.getItem("BlnLahir") : ''),
        TglLahir: ((localStorage.getItem("step_status") !== null) ? localStorage.getItem("TglLahir") : ''),
      },
      errorValidator: {
        errorNIK: false,
        errorNamaLengkap: false,
        errorThnLahir: false,
        errorBlnLahir: false,
        errorTglLahir: false,
      },
      show: false,
      formError: '',
      loading: false,
    }
  }

  onChange(event) {
    // console.log('--------------',event)

    const { data_step_1, data_step_2, data } = this.state;
    data_step_1[event.target.name] = event.target.value;
    data_step_2[event.target.name] = event.target.value;
    data[event.target.name] = event.target.value

    localStorage.setItem(event.target.name, data_step_1[event.target.name]);
    localStorage.setItem(event.target.name, data_step_2[event.target.name]);
    localStorage.setItem(event.target.name, data[event.target.name])

    this.setState({ data_step_1 });
    this.setState({ data_step_2 });
    this.setState({ data })
    // console.log(localStorage)

    // validator made by alfan
    this.errorHandler(event.target.name, event.target.value)
  }

  setGoogleConvScript() {
    const script = `
    <!-- Google Code for Submit Leads Conversion Page -->

    <script type="text/javascript">

    /* <![CDATA[ */

    var google_conversion_id = 833428422;

    var google_conversion_language = "en";

    var google_conversion_format = "3";

    var google_conversion_color = "ffffff";

    var google_conversion_label = "JWyFCN_yv3UQxre0jQM";

    var google_remarketing_only = false;

    /* ]]> */

    </script>

    <script type="text/javascript" src="//www.googleadservices.com/pagead/conversion.js">

    </script>

    <noscript>

    <div style="display:inline;">

    <img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/833428422/?label=JWyFCN_yv3UQxre0jQM&amp;guid=ON&amp;script=0"/>

    </div>

    </noscript>
`

    function createMarkup() {
      return {__html: script}
    }
    return <div className="conversionScript" dangerouslySetInnerHTML={createMarkup()} />
  }

  // validator made by alfan
  errorHandler(key, value = 0, event='change') {

    // console.log('event', event)
    const { data_step_2, data_diri_style } = this.state;

    // console.log('-----key', key, value)
    switch (key) {
      case 'NamaLengkap': {
        // console.log('nama lengkap')
        if (value === '') {
          this.state.errorValidator.errorNamaLengkap = true
          this.state.errorValidator.errorNamaLengkapMessage = 'Nama harus di isi'
        } else {
          this.state.errorValidator.errorNamaLengkap = value.match(/^[a-zA-Z ]+$/) === null
          this.state.errorValidator.errorNamaLengkapMessage = 'Nama tidak boleh terdapat angka atau karakter spesial'
        }

        if (localStorage.getItem('step_status') === '2' && this.state.errorValidator.errorNamaLengkap === true) {
          this.state.data_diri_style.NamaInputShow = 'block'
          this.state.data_diri_style.NamaLabelShow = 'none'
        }
      } break;
      case 'Alamat': {
        value === '' ? this.state.errorValidator_step_1.errorAlamat = true : this.state.errorValidator_step_1.errorAlamat = false

        if (localStorage.getItem('step_status') === '2' && this.state.errorValidator_step_1.errorAlamat === true) {
          this.state.data_diri_style.AlamatInputShow = 'block'
          this.state.data_diri_style.AlamatLabelShow = 'none'
        }
      } break;
      case 'PeriodeProgram': {
        ( value === '') ? this.state.errorValidator_step_2.errorPeriodeProgram = true :
          this.state.errorValidator_step_2.errorPeriodeProgram = false

        if (localStorage.getItem('step_status') === '2' && this.state.errorValidator_step_2.errorPeriodeProgram === true) {
          this.state.data_diri_style.PeriodeProgramInputShow = 'flex'
          this.state.data_diri_style.PeriodeProgramLabelShow = 'none'
        }

      } break;
      case 'Email': {
        if (value === '') {

          this.state.errorValidator_step_1.errorEmail = true
          this.state.errorValidator_step_1.errorEmailMessage = 'Email tidak boleh kosong'
        } else {

          this.state.errorValidator_step_1.errorEmail = value.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) === null

          this.state.errorValidator_step_1.errorEmailMessage = 'Email tidak sesuai dengan format'
        }

        if (localStorage.getItem('step_status') === '2' && this.state.errorValidator_step_1.errorEmail === true) {
          this.state.data_diri_style.EmailInputShow = 'block'
          this.state.data_diri_style.EmailLabelShow = 'none'
        }
      } break;
      case 'NoPonsel': {
        if (value === '') {
          this.state.errorValidator_step_1.errorNoPonsel = true
          this.state.errorValidator_step_1.errorNoPonselMessage = 'Nomor handphone tidak boleh kosong'
        } else {
          this.state.errorValidator_step_1.errorNoPonsel = value.match(/^\+?620?8[0-9]{8,11}$|^08[0-9]{8,11}$|^0[0-9]{2}9[0-9]{8,11}$/) === null
          this.state.errorValidator_step_1.errorNoPonselMessage = 'Nomor handphone tidak sesuai format'
        }
      } break;
      case 'Gaji': {
        if (value === '') {
          this.state.errorValidator_step_2.errorGaji = true
          this.state.errorValidator_step_2.errorGajiMessage = 'Gaji tidak boleh kosong'
        } else {
          this.state.errorValidator_step_2.errorGaji = value.match(/^[1-9][0-9]{4,}$/) === null
          this.state.errorValidator_step_2.errorGajiMessage = 'Gaji harus angka dan minimal 4 digit angka tanpa koma, di awali angka bukan 0'
        }

        if (localStorage.getItem('step_status') === '2' && this.state.errorValidator_step_2.errorGaji === true) {
          this.state.data_diri_style.GajiInputShow = 'block'
          this.state.data_diri_style.GajiLabelShow = 'none'
        }

      } break;
      case 'Pekerjaan': {
        if (value === '') {
          this.state.errorValidator_step_2.errorPekerjaan = true
          this.state.errorValidator_step_2.errorPekerjaanMessage = 'Pekerjaan tidak boleh kosong'
        } else {
          this.state.errorValidator_step_2.errorPekerjaan = value.match(/^[a-zA-Z ]+$/) === null
          this.state.errorValidator_step_2.errorPekerjaanMessage = 'Pekerjaan tidak boleh memiliki angka dan karakter spesial (!@#$%^&*)'
        }

        if (localStorage.getItem('step_status') === '2' && this.state.errorValidator_step_2.errorPekerjaan === true) {
          this.state.data_diri_style.PekerjaanInputShow = 'block'
          this.state.data_diri_style.PekerjaanLabelShow = 'none'
        }

      } break;
      case 'NoVerifikasiSMS': {
        if (value === '') {
          this.state.errorValidator_step_2.errorNoVerifikasiSMS = true
          this.state.errorValidator_step_2.errorNoVerifikasiSMSMessage = 'Nomor verifikasi SMS harus di isi'
        } else {
          this.state.errorValidator_step_2.errorNoVerifikasiSMS = value.match(/^[0-9]{6,6}$/) === null
          this.state.errorValidator_step_2.errorNoVerifikasiSMSMessage = 'Nomor verifikasi SMS teridiri dari 6 digit angka'
        }

        if (localStorage.getItem('step_status') === '2' && this.state.errorValidator_step_2.errorNoVerifikasiSMS === true) {
          this.state.data_diri_style.NoVerifikasiSMSLabelShow = 'none'
          this.state.data_diri_style.NoVerifikasiSMSInputShow = 'block'
        }

      } break;
      case 'Provinsi': {
        if (value === '') {
          // set kota and cabang blank when provinsi change
          data_step_2.Kota = ''
          data_step_2.Cabang = ''
          data_step_2.Provinsi = ''

          localStorage.setItem('Kota', '')
          localStorage.setItem('Cabang', '')
          localStorage.setItem('Provinsi', '')

          this.setState({ data_step_2 });

          this.state.errorValidator_step_2.errorProvinsi = true
        } else {

          // if just change provinsi reset cabang and provinsi so drop down will clear
          if (event !== 'submit') {
            // console.log('masuk')
            data_step_2.Kota = ''
            data_step_2.Cabang = ''
            data_step_2.Provinsi = value

            localStorage.setItem('Kota', '')
            localStorage.setItem('Cabang', '')
            localStorage.setItem('Provinsi', value)

            this.setState({ data_step_2 });
          }

          this.state.errorValidator_step_2.errorProvinsi = false
        }
      } break
      case 'Kota': {
        if (value === '') {
          this.state.errorValidator_step_2.errorKota = true
        } else {
          // if just change provinsi reset cabang and provinsi so drop down will clear
          if (event !== 'submit') {
            // console.log('masuk kota')
            data_step_2.Kota = value
            data_step_2.Cabang = ''

            localStorage.setItem('Kota', value)
            localStorage.setItem('Cabang', '')
 
            this.setState({ data_step_2 });
          }
          
          this.state.errorValidator_step_2.errorKota = false
        } 
      } break
      case 'Cabang': {
        value === '' ? this.state.errorValidator_step_2.errorCabang = true : this.state.errorValidator_step_2.errorCabang = false
      } break
      case 'JamMasukKantor': {
        value === '' ? this.state.errorValidator_step_2.errorJamMasukKantor = true : this.state.errorValidator_step_2.errorJamMasukKantor = false       

        if (localStorage.getItem('JamMasukKantor') !== null && localStorage.getItem('JamKeluarKantor') !== null) {
          this.checkJamMasukJamKeluar()
        }

        if (localStorage.getItem('step_status') === '2' && this.state.errorValidator_step_2.errorJamMasukKantor === true) {
          this.state.data_diri_style.JamMasukKantorLabelShow = 'none'
          this.state.data_diri_style.JamMasukKantorInputShow = 'block'
        }

      } break
      case 'JamKeluarKantor': {
        value === '' ? this.state.errorValidator_step_2.errorJamKeluarKantor = true : this.state.errorValidator_step_2.errorJamKeluarKantor = false

        if (localStorage.getItem('JamMasukKantor') !== null && localStorage.getItem('JamKeluarKantor') !== null ) {
          this.checkJamMasukJamKeluar()
        }

        if (localStorage.getItem('step_status') === '2' && this.state.errorValidator_step_2.errorJamKeluarKantor === true) {
          this.state.data_diri_style.JamMasukKantorLabelShow = 'none'
          this.state.data_diri_style.JamMasukKantorInputShow = 'block'
        }

      } break

      default:
        break;
    }
  }

  // check jam keluar kantor dan jam masuk kantor 

  checkJamMasukJamKeluar() {
    // check jam masuk kantor 
    if (Number(localStorage.getItem('JamMasukKantor').split(':')[0]) >= Number(localStorage.getItem('JamKeluarKantor').split(':')[0])) {
      this.state.errorValidator_step_2.errorJamKantor = true
      this.state.errorValidator_step_2.errorJamKantorMessage = 'Jam masuk kantor harus lebih kecil dari pada jam keluar kantor'

      // check for step
      if (localStorage.getItem('step_status') === '2') {
        this.state.data_diri_style.JamMasukKantorLabelShow = 'none'
        this.state.data_diri_style.JamMasukKantorInputShow = 'block'
      }

    } else {
      this.state.errorValidator_step_2.errorJamKantor = false
    }
  }

  // check data before sent 
  checkData(dataErrorValidator, data, callback) {
    // check to validator first
    // console.log(data)
    try {
      for (var key in data) {
        this.errorHandler(key, data[key], 'submit')
      }

      if (localStorage.getItem('step_status') === '2') {

      }
    }
    catch(err) {
      console.log(err)
    }
    finally {
      // check error
      for (var key in dataErrorValidator) {
        if (dataErrorValidator[key] === true) {
          return callback(true)
        }
      }
      return callback(false)
    }
  }

  componentWillMount() {
    if (this.props.location.search !== "") {
      if (localStorage.getItem('step_status') === null) {
        
        const params = this.props.location.search
        const data = parseUrl(params)
        const nama = data[1].replace(/\+/g, ' ')
        // console.log(nama)
        let [TglLahir, BlnLahir, ThnLahir] = data[2].split('-')
        localStorage.setItem('NIK', data[0])
        localStorage.setItem('NamaLengkap', nama)
        localStorage.setItem('TglLahir', TglLahir)
        localStorage.setItem('BlnLahir', BlnLahir)
        localStorage.setItem('ThnLahir', ThnLahir)
        // add dumy number 
        localStorage.setItem('NoPonsel', '081234567890')

        let peserta = localStorage
        verifyKTP(peserta)
        .then((result) => {
          let self = this.state
          // console.log(result)
          // add address to localstorage
          localStorage.setItem('Alamat', result.data.ALAMAT_KTP + ' Kel.' + result.data.KEL_KTP + ' Kec.' + result.data.KEC_KTP + ' Kab.' + result.data.KAB_KTP + ', ' + result.data.PROP_KTP + ', ' + result.data.KODEPOS_KTP)

          self.data.NIK = localStorage.getItem('NIK')
          self.data.NamaLengkap = localStorage.getItem('NamaLengkap')
          self.data.TglLahir = localStorage.getItem('TglLahir')
          self.data.BlnLahir = localStorage.getItem('BlnLahir')
          self.data.ThnLahir = localStorage.getItem('ThnLahir')
          self.data_step_1.Alamat = localStorage.getItem('Alamat')

          this.setState({self})
          // console.log(this.state)
        })
        .catch((error) => {
          
          if (error.msg === 'Error: java.net.SocketTimeoutException: Read timed out') {
            error.msg = 'Gagal tersambung dengan server'
          }

          localStorage.setItem('formError', error.msg)
          const { history } = this.props
          history.push('/')
        })
      } else if (Number(localStorage.getItem('step_status')) === 1) {
        ClearLocalStorageStep2()
      } else if (Number(localStorage.getItem('step_status')) === 0) {
        ClearLocalStorageStep1()
      }
      
    } else {
      // console.log('---console',localStorage.getItem('step_status'))

      // detection step to clear local storage if refresh the page
      if (localStorage.getItem('step_status') === null) {
        // console.log('masuk')
        localStorage.setItem('formError', 'Harus mengisi data awal terlebih dahulu')
        const { history } = this.props
        history.push('/')
      } else if (Number(localStorage.getItem('step_status')) === 1) {
        ClearLocalStorageStep2()
      } else if (Number(localStorage.getItem('step_status')) === 0) {
        ClearLocalStorageStep1()
      }
    }
  }

  handleNext = () => {
    const { route } = this.props;
    const { data_step_1, data_step_2, errorValidator_step_1, errorValidator_step_2, stepIndex, modalPenjelasan } = this.state;
    let _this = this;
    if (stepIndex === 0) {
      this.checkData(this.state.errorValidator_step_1, this.state.data_step_1, (check)=>{
        // console.log('check', check)
        Validator(data_step_1).then(async result => {
          if (check === true) {
            result.forEach((val, index) => {
              errorValidator_step_1['error' + val] = true;
              _this.setState({ errorValidator_step_1 });
            })
          } else {
            if (stepIndex < 2) { // But why, step indexnya kan 0, pasti kurang dari dua dul
              if (process.env.NODE_ENV !== 'development') {
                const peserta = localStorage
                try {
                  // fix after enter cannot start to new step
                  localStorage.setItem('step_status', 1)

                  this.setState({ loading: true })
                  const result = await verifyKTP(peserta)
                  this.setState({
                    smsotp: result.smsotp,
                    stepIndex: stepIndex + 1,
                    formError: '',
                    loading: false,
                  })
                } catch (error) {
                  this.setState({
                    stepIndex: 0,
                    formError: {
                      step: 0,
                      msg: error.msg,
                    },
                    loading: false,
                  })

                  if (error.msg === 'Error: java.net.SocketTimeoutException: Read timed out') 
                  {
                    error.msg = 'Gagal tersambung dengan server'
                  }
                  localStorage.setItem('formError', error.msg)
                  const { history } = this.props
                  history.push('/')
                }
              } else {
                localStorage.setItem('step_status', 1)
                // console.log('execute this')
                _this.setState({ stepIndex: stepIndex + 1 });
              }
            }
          }
        })
      })
      // Validator(data_step_1).then(async result => {
      //   if (result.length === 0) {
      //     if (stepIndex < 2) { // But why, step indexnya kan 0, pasti kurang dari dua dul
      //       if (process.env.NODE_ENV !== 'development') {
      //         const peserta = localStorage
      //         try {
      //           this.setState({loading: true})
      //           const result = await verifyKTP(peserta)
      //           this.setState({
      //             smsotp: result.smsotp,
      //             stepIndex: stepIndex + 1,
      //             formError: '',
      //             loading: false,
      //           })
      //           localStorage.setItem('step_status', 1)
      //         } catch (error) {
      //           this.setState({
      //             stepIndex: 0,
      //             formError: {
      //               step: 0,
      //               msg: error.msg,
      //             },
      //             loading: false,
      //           })
      //           localStorage.setItem('formError', error.msg)
      //           const { history } = this.props
      //           history.push('/')
      //         }
      //       } else {
      //         localStorage.setItem('step_status', 1)
      //         console.log('execute this')
      //         _this.setState({stepIndex: stepIndex + 1});
      //       }
      //     }
      //   } else {
      //     result.forEach((val, index) => {
      //       errorValidator_step_1['error'+val] = true;
      //       _this.setState({ errorValidator_step_1 });
      //     })
      //   }
      // })
    }else if (stepIndex === 1) {
      // console.log('-----get JTH', localStorage.getItem('JHT'))

      // add by alfan to anticipate bug people not choose jht
      this.state.data_step_2.Program = 'JHT'
      if (localStorage.getItem('JHT') === null) 
      {
        localStorage.setItem('JHT', false)
      }
      
      this.checkData(this.state.errorValidator_step_2, this.state.data_step_2, (check) => {
        // console.log('check', check)
        Validator(data_step_2).then(result => {
          if (check === true) {
            result.forEach((val, index) => {
              errorValidator_step_2['error' + val] = true;
              _this.setState({ errorValidator_step_2 });
            })
          } else {
            if (result.length === 0) {
              localStorage.setItem('step_status', 2)
              if (stepIndex < 2) {
                _this.setState({ stepIndex: stepIndex + 1 });
              }
            }
          }
        })  
      })
      
      // Validator(data_step_2).then(result => {
      //   if (result.length === 0) {
      //     localStorage.setItem('step_status', 2)
      //     if (stepIndex < 2) {
      //       _this.setState({stepIndex: stepIndex + 1});
      //     }
      //   }else {
      //     result.forEach((val, index) => {
      //       errorValidator_step_2['error'+val] = true;
      //       _this.setState({ errorValidator_step_2 });
      //     })
      //   }
      // })
    }else if (stepIndex === 2) {


      const processRegister = async () =>
      {
        const peserta = localStorage
        if (peserta.NIK === "3921010207976665") {
          this.setState({
            modalPenjelasan: {
                ...modalPenjelasan,
                display: 'block',
            },
            formError: '',
            loading: false,
          });
          return
        }
        try {
          this.setState({loading: true})
          const result = await register(peserta)
          try {
            const kodeIuran = await prosesKodeIuran(peserta)
            const kode = kodeIuran.kodeIuran
            const dataIuran = kodeIuran.dataIuran
            this.setState({
              iuran: {
                ...this.state.iuran,
                dataIuran: {...dataIuran},
                kodeIuran: kode,
              },
              modalPenjelasan: {
                  ...modalPenjelasan,
                  display: 'block',
              },
              formError: '',
              loading: false,
            });
          } catch (error) {
            this.setState({
              formError: {
                msg: error.msg,
                step: 2,
              },
              loading: false,
            })
            // console.log(this.state)
          }
        } catch (error) {
          this.setState({
            formError: {
              msg: error.msg,
              step: 2,
            },
            loading: false,
          })
        }
      }

      // add by alfan, to check user information needed before call api or summit data 
      this.checkData(this.state.errorValidator, this.state.data, (check) => {
        // console.log('check1', check)
        this.checkData(this.state.errorValidator_step_1, this.state.data_step_1, (check2) => {
          // console.log('check2', check2)
          this.checkData(this.state.errorValidator_step_2, this.state.data_step_2, (check3) => {
            // console.log('check3', check3)
            if(!check && !check2 && !check3) {
              processRegister()
            } else {
              // console.log('ada error')
              this.setState(this.state)
            }
          })
        })
      })
    }
  };

  showIuran = async (e) => {
    // console.log('---masuk')
    e.preventDefault()
    const peserta = localStorage
    try {
      const result = await hitungIuran(peserta)
      // console.log(`result----------`,result)
      this.setState({
        iuran: {
          kode: result.kode,
          dataIuran: {...result.dataIuran},
        },
        tampilkanPerhitunganIuran: 'block',
        formError: '',
      })
    }
    catch (error) {
      this.setState({ formError: error.msg })
    }
  }

  handlePrev = () => {
    const {stepIndex} = this.state;
    if (stepIndex > 0) {
      this.setState({stepIndex: stepIndex - 1});
    }
  };

  modalPenjelasan(status) {
    const { modalStyle } = this.state;
    if (status) {
      this.setState({
        modalStyle: {
            ...modalStyle,
            display: 'block'
        }
      });
    }else {
      this.setState({
        modalStyle: {
            ...modalStyle,
            display: 'none'
        }
      });
    }
  }

  onDropdownChange = (key, value, event='') => {
    // console.log(event.target.selectedIndex)
    // console.log(event.target[event.target.selectedIndex].text)

    this.setState({
      data_step_2: {
        ...this.state.data_step_2,
        [key]: value
      }
    })
    localStorage.setItem(key, value)
    // console.log(localStorage)

    // save nama provinis, kota, cabang
    localStorage.setItem('nama' + key, event.target[event.target.selectedIndex].text)

    // validator made by alfan
    this.errorHandler(key, value)
  }

  modalAgreement(status) {
    const { modalPenjelasan } = this.state;
    if (status) {
      this.setState({
        modalPenjelasan: {
            ...modalPenjelasan,
            display: 'block'
        }
      });
    }else {
      this.setState({
        modalPenjelasan: {
            ...modalPenjelasan,
            display: 'none'
        }
      });
    }

  }

  modalPembayaran() {
    const { modalPembayaran, modalPenjelasan } = this.state;
    this.setState({
      modalPembayaran: {
          ...modalPembayaran,
          display: 'block'
      }
    });
    this.setState({
      modalPenjelasan: {
          ...modalPenjelasan,
          display: 'none'
      }
    });
  }

  modalContentAgreement() {
    return(
      <div>
        <div className="w3-content w3-padding-32 w3-margin" style={{lineHeight: '28px', color: '#4A4A4A'}}>
          <p style={{marginBottom: '30px'}} className="modal-justify">Dengan ini saya menyatakan bahwa saya memahami dan mengerti sepenuhnya serta dalam keadaan sadar dan tanpa ada paksaan dari pihak manapun, oleh karenanya saya berjanji, sepakat, menyetujui dan menyatakan bahwa :</p>
          <p className="modal-justify">1.	Kepesertaan BPJS Ketenagakerjaan akan mulai berlaku jika saya telah dan terus melakukan pembayaran Premi sesuai dengan syarat dan ketentuan dalam [polis BPJS Ketenagakerjaan.</p>
          <p className="modal-justify">2.	Saya bersedia untuk dihubungi oleh pihak dari PasarPolis semata-mata untuk kepentingan konfirmasi kepesertaan BPJS Ketenagakerjaan dan informasi mengenai produk perlindungan relevan lainnya.</p>
        </div>

        <div className="w3-container w3-padding-16">
          <button id='acceptDisclaimer' onClick={() => this.modalPembayaran()} type="button" className="w3-right w3-btn w3-padding-16 button-modal-full" style={{width: '110px', background: '#4A90E2', color: '#FFF', marginBottom: '20px', marginLeft: '20px', marginTop: '-20px'}}>YA</button>
          <button onClick={() => this.modalAgreement(false)} type="button" className="w3-right w3-btn w3-padding-16 w3-margin-right button-modal-full" style={{width: '110px', background: '#F0F4F8', color: '#4A90E2', marginTop: '-20px'}}>TIDAK</button>
        </div>
      </div>
    )
  }

  modalContentPembayaran() {
    const { modalPembayaran } = this.state;
    console.log(this.state)
    return(
      <div>
        {/* Google Tag Manager */}
        {(this.state.modalPembayaran.display === 'block') ? this.setGoogleConvScript(): ""}
        {/* End Google Tag Manager */}
        <div className="w3-content w3-padding-16 w3-margin custom-content-modal-text">
          <p className="custom-title-modal modal-justify"><b>Terimakasih Anda telah memilih Pasarpolis.</b></p>
          <p style={{letterSpacing: '.5px'}} className="modal-justify">Anda telah berhasil terdaftar sebagai anggota BPJS ketenagakerjaan. Mohon diingat bahwa pendaftaran Anda belum lengkap apabila Anda belum melakukan pembayaran.</p>
          <p className="modal-justify">Rincian Pembayaran BPJS ketenagakerjaan Anda</p>
        </div>
        <div className="w3-container w3-margin-bottom custom-modal-container">
          <table className="table-pembayaran">
            <tr>
              <td style={{float: 'left', marginRight: '15px'}}>NIK</td>
              <td ></td>
              <td>{localStorage.NIK}</td>
            </tr>
            <tr>
              <td>JKK (Jaminan Kecelakaan Kerja)</td>
              <td>:</td>
              <td><b>Rp { this.state.iuran && this.state.iuran.dataIuran.PROG_JKK ? moneyFormat(this.state.iuran.dataIuran.PROG_JKK.split(':')[0]) : 0 }</b></td>
            </tr>
            <tr className="w3-margin-top w3-margin-bottom">
              <td>JHT (Jaminan Hari Tua)</td>
              <td>:</td>
              <td><b>Rp { this.state.iuran && this.state.iuran.dataIuran.PROG_JHT ? moneyFormat(this.state.iuran.dataIuran.PROG_JHT.split(':')[0]) : 0 }</b></td>
            </tr>
            <tr className="w3-margin-top w3-margin-bottom">
              <td>JKM (Jaminan Kematian)</td>
              <td>:</td>
              <td><b>Rp { this.state.iuran && this.state.iuran.dataIuran.PROG_JKM ? moneyFormat(this.state.iuran.dataIuran.PROG_JKM.split(':')[0]) : 0 }</b></td>
            </tr>
          </table>
          <table className="table-pembayaran-mobile">
            <tr>
              <td style={{float: 'left', marginRight: '15px'}}>NIK</td>
              <td ></td>
              <td>{localStorage.NIK}</td>
            </tr>
            <tr>
              <td style={{width: '50px'}}>JKK</td>
              <td>:</td>
              <td><b>Rp { this.state.iuran && this.state.iuran.dataIuran.PROG_JKK ? moneyFormat(this.state.iuran.dataIuran.PROG_JKK.split(':')[0]) : 0 }</b></td>
            </tr>
            <tr className="w3-margin-top w3-margin-bottom">
              <td>JHT</td>
              <td>:</td>
              <td><b>Rp { this.state.iuran && this.state.iuran.dataIuran.PROG_JHT ? moneyFormat(this.state.iuran.dataIuran.PROG_JHT.split(':')[0]) : 0 }</b></td>
            </tr>
            <tr className="w3-margin-top w3-margin-bottom">
              <td>JKM</td>
              <td>:</td>
              <td><b>Rp { this.state.iuran && this.state.iuran.dataIuran.PROG_JKM ? moneyFormat(this.state.iuran.dataIuran.PROG_JKM.split(':')[0]) : 0 }</b></td>
            </tr>
          </table>
          <table style={{width:'100%',color: '#FFF'}}>
            <tr style={{backgroundColor: '#4A4A4A'}}>
              <td style={{padding: '10px', width: '100px',border: 'none !important'}}>Total</td>
              <td style={{float: 'right', marginTop: '10px', marginRight: '10px'}}><b>Rp { this.state.iuran ? moneyFormat(this.state.iuran.dataIuran.TOTAL) : 0 }</b></td>
            </tr>
          </table>

        </div>
        <div  className="w3-content w3-padding-16 w3-margin custom-content-modal-text">
          <strong>Pembayaran bisa dilakukan di: </strong>
          <ol>
            <li>ATM & Teller di Bank BNI, BRI, Mandiri, BCA, Bukopin, BTN, BJB untuk pembayaran tanpa dikenakan biaya administras</li>
            <li>Gerai Indomaret dan Alfamart (Biaya administrasi Rp.3500/transaksi)</li>
          </ol>
          <p className="modal-justify">
            Anda akan menerima email konfirmasi dari pasarpolis yang bisa Anda print dan bawa ke kantor cabang BPJS ketenagakerjaan terdekat untuk ditukarkan dengan kartu kepesertaan BPJS ketenagakerjaan
          </p>
        </div>
        <div className="w3-container w3-padding-16" style={{marginTop: '20px', marginBottom: '20px'}}>
          <button onClick={() => {
            this.setState({
              modalPembayaran: {
                  ...modalPembayaran,
                  // display: 'none'
              },
              paymentOptionsStep: true,
            })
            const { history } = this.props
            history.push('/')

            // add by alfan to clear local storage
            ClearLocalStorageAll()
          }} type="button" className="w3-right w3-btn w3-padding-16 button-modal-pembayaran" style={{background: '#4A90E2', color: '#4A90E2', marginTop: '-20px', fontSize: '14px', letterSpacing: '1px', color: '#FFF', fontWeight: 'bold', letterSpacing: '1.5px'}}>KEMBALI KE PENDAFTARAN</button>
        </div>
      </div>
    )
  }

  modalContentPaymentOptions() {
    return(
      <div className="payment-options">
        {
          this.state.iuran !== undefined ?
          <Pembayaran 
            nik={localStorage.getItem("NIK")}
            program={this.state.data_step_2.Program}
            dataIuran={this.state.iuran.dataIuran}
            period={localStorage.getItem("PeriodeProgram")} 
            kodeIuran={this.state.iuran.kodeIuran} />
          : ""
        }
      </div>
    )
  }

  modalContent() {
    return(
      <div className="w3-content w3-padding">
        <h3>Program BPJS Ketenagakerjaan</h3>
        <p>Saat ini sudah ada 6 program BPJS Ketenagakerjaan yang bisa didapatkan sesuai dengan kebutuhan Anda:</p>

        <p><b>a. Jaminan Hari Tua (JHT)</b></p>
        <p className="ketenagakerjaan-modal">Manfaat program JHT yaitu peserta bisa mendapatkan uang tunai yang besarnya dari hasil nilai akumulasi iuran ditambah dengan hasil pengembangannya dan dibayarkan sekaligus apabila peserta telah mencapai usia 56 tahun, meninggal dunia, mengalami cacat total tetap, terkena PHK atau mengundurkan diri disaat sudah memasuki usia pensiun.</p>

        <p><b>b. Jaminan Kecelakaan Kerja (JKK)</b></p>
        <p className="ketenagakerjaan-modal">Program JKK dapat memberikan manfaat pelayanan kesehatan yaitu santunan berupa uang. Dengan program ini, peserta mendapat perlindungan atas risiko-risiko kecelakaan kerja yang terjadi dalam hubungan kerja, termasuk jika terjadinya kecelakaan yang terjadi dalam perjalanan dari rumah menuju tempat kerja atau sebaliknya dan juga penyakit yang disebabkan oleh lingkungan kerja.</p>

        <p><b>c. Jaminan Kematian (JKM)</b></p>
        <p className="ketenagakerjaan-modal">Manfaat dari program JKM diperuntukkan bagi ahli waris dari peserta program BPJS Ketenagakerjaan yang meninggal dunia bukan karena kecelakaan kerja. Jadi apabila tenaga kerja alias peserta BPJS Ketenagakerjaan merupakan pencari nafkah keluarga, pihak ahli waris tidak akan terlantar kehidupan nya setelah pencari nafkah meninggal dunia. Jika peserta sudah memiliki masa iuran minimal 5 tahun, maka akan diberikan juga beasiswa pendidikan anak.</p>

        <p><b>d. Bukan Penerima Upah (BPU)</b></p>
        <p className="ketenagakerjaan-modal">Program BPU adalah program yang diperuntukkan untuk mereka yang bekerja dengan melakukan kegiatan atau usaha ekonomi secara mandiri untuk memperoleh penghasilan dari usahanya tersebut. Misalnya, photographer, montir, supir angkot, pedagang, dokter, penjual online, dan lain-lain. BPU bisa mendapatkan hasil program JHT, JK dan JKK seperti mereka yang menerima upah atau bekerja di sebuah perusahaan.</p>

        <p><b>e. Jasa Konstruksi</b></p>
        <p className="ketenagakerjaan-modal">Kepesertaan dari program ini diperuntukan khususnya bagi pekerja di bidang usaha jasa konstruksi, baik itu pekerja lepas, borongan, maupun perjanjian kerja waktu tertentu. Sebelum memulai pekerjaan, para peserta biasanya di daftarkan oleh pemborong bangunan (kontraktor) untuk program JKK dan JKM.</p>

        <p><b>e. Jasa Konstruksi</b></p>
        <p className="ketenagakerjaan-modal">Kepesertaan dari program ini diperuntukan khususnya bagi pekerja di bidang usaha jasa konstruksi, baik itu pekerja lepas, borongan, maupun perjanjian kerja waktu tertentu. Sebelum memulai pekerjaan, para peserta biasanya di daftarkan oleh pemborong bangunan (kontraktor) untuk program JKK dan JKM.</p>

        <p><b>f. Jaminan Pensiun</b></p>
        <p className="ketenagakerjaan-modal">Program jaminan pensiun bermanfaat untuk memberikan kehidupan yang sesuai bagi para peserta dan/atau ahli warisnya dengan memberikan penghasilan setiap bulannya setelah peserta memasuki usia pensiun, mengalami cacat total tetap, atau meninggal dunia.</p>

      </div>
    )
  }

  showModal() {
    this.setState({show: true});
  }

  hideModal() {
    this.setState({show: false});
  }

  getStepContent(stepIndex) {

    const { modalStyle, modalPenjelasan, modalPembayaran, data_step_1, data_step_2, data_diri_style } = this.state;
    const { Email, NoPonsel, Alamat } = this.state.data_step_1;
    const { Provinsi, Kota, Cabang, Pekerjaan, Gaji, JamMasukKantor, JamKeluarKantor, Program, PeriodeProgram, NoVerifikasiSMS } = this.state.data_step_2;
    const { errorEmail, errorNoPonsel, errorAlamat } = this.state.errorValidator_step_1;
    const { errorProvinsi, errorKota, errorCabang, errorPekerjaan, errorGaji, errorJamMasukKantor, errorJamKeluarKantor, errorProgram, errorPeriodeProgram, errorNoVerifikasiSMS,errorJamKantor } = this.state.errorValidator_step_2;
    const {
      NIKLabelShow, NIKInputShow, NamaLabelShow, NamaInputShow, TglLahirLabelShow, TglLahirInputShow,
      EmailLabelShow, EmailInputShow, NoTlpLabelShow, NoTlpInputShow, AlamatLabelShow, AlamatInputShow,
      ProvinsiLabelShow, ProvinsiInputShow, KotaLabelShow, KotaInputShow, CabangLabelShow, CabangInputShow,
      PekerjaanLabelShow, PekerjaanInputShow, GajiLabelShow, GajiInputShow, JamMasukKantorLabelShow, JamMasukKantorInputShow,
      PeriodeProgramLabelShow, PeriodeProgramInputShow, NoVerifikasiSMSLabelShow, NoVerifikasiSMSInputShow, ProgramInputShow, ProgramLabelShow
    } = this.state.data_diri_style;

    let errorFieldEmail, errorFieldNoPonsel, errorFieldAlamat;
    (errorEmail) ? errorFieldEmail = {border: 'solid 1px #D0021B'} : '';
    (errorNoPonsel) ? errorFieldNoPonsel = {border: 'solid 1px #D0021B'} : '';
    (errorAlamat) ? errorFieldAlamat = {border: 'solid 1px #D0021B'} : '';

    let errorFieldProvinsi, errorFieldKota, errorFieldCabang, errorFieldPekerjaan, errorFieldGaji, errorFieldJamMasukKantor, errorFieldJamKeluarKantor, errorFieldProgram, errorFieldPeriodeProgram, errorFieldNoVerifikasiSMS;
    (errorProvinsi) ? errorFieldProvinsi = {border: 'solid 1px #D0021B'} : '';
    (errorKota) ? errorFieldKota = {border: 'solid 1px #D0021B'} : '';
    (errorCabang) ? errorFieldCabang = {border: 'solid 1px #D0021B'} : '';
    (errorPekerjaan) ? errorFieldPekerjaan = {border: 'solid 1px #D0021B'} : '';
    (errorGaji) ? errorFieldGaji = {border: 'solid 1px #D0021B'} : '';
    (errorJamMasukKantor) ? errorFieldJamMasukKantor = {border: 'solid 1px #D0021B'} : '';
    (errorJamKeluarKantor) ? errorFieldJamKeluarKantor = {border: 'solid 1px #D0021B'} : '';
    (errorProgram) ? errorFieldProgram = {border: 'solid 1px #D0021B'} : '';
    (errorPeriodeProgram) ? errorFieldPeriodeProgram = {border: 'solid 1px #D0021B'} : '';
    (errorNoVerifikasiSMS) ? errorFieldNoVerifikasiSMS = {border: 'solid 1px #D0021B'} : '';

    const {NIK, NamaLengkap, ThnLahir, BlnLahir, TglLahir} = this.state.data;
    const { errorNIK, errorNamaLengkap, errorThnLahir, errorBlnLahir, errorTglLahir } = this.state.errorValidator;

    let errorFieldNIK, errorFieldNamaLengkap, errorFieldThnLahir, errorFieldBlnLahir, errorFieldTglLahir;
    (errorNIK) ? errorFieldNIK = {border: 'solid 1px #D0021B'} : '';
    (errorNamaLengkap) ? errorFieldNamaLengkap = {border: 'solid 1px #D0021B'} : '';
    (errorThnLahir) ? errorFieldThnLahir = {border: 'solid 1px #D0021B'} : '';
    (errorBlnLahir) ? errorFieldBlnLahir = {border: 'solid 1px #D0021B'} : '';
    (errorTglLahir) ? errorFieldTglLahir = {border: 'solid 1px #D0021B'} : '';

    switch (stepIndex) {
      case 0:
        return (
          <div className="container" id="content-step">
              <div className="row year-section" >
                <div className="col-xs-12 col-md-6 col-lg-6">
                  <div style={{display:'flex', flexDirection: 'row', marginBottom: '50px'}}>
                    <h2><b className="custom-data-title">Lengkapi data diri anda..</b></h2>
                  </div>
                  <form>
                    <div>
                    <label className="custom-label">
                      <b>Email</b>
                      <span style={{marginLeft: '10px', color: '#FFB200'}} className="hidden-sm hidden-md hidden-lg">
                        <i className="fa fa-question-circle w3-tooltip" aria-hidden="true"><span style={{position:'absolute',left:'0',bottom:'18px', padding: '10px'}} className="w3-text w3-tag">Email, nomor ponsel dan alamat sangat diperlukan karena BPJS membutuhkan data kependudukan anda.</span></i>
                      </span>
                    </label>
                    <input onChange={(val) => this.onChange(val)} value={Email} name="Email" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field" type="text" style={errorFieldEmail} placeholder="mohammadlegad@gmail.com"/>
                    
                    { // modified by alfan for validator
                      (errorEmail) ? <p className="custom-error-field">
                      {(this.state.errorValidator_step_1.errorEmailMessage !== null) ? this.state.errorValidator_step_1.errorEmailMessage : 'Email Tidak boleh kosong'}</p> : '' }

                    <label className="custom-label"><b>Nomor Ponsel</b></label>
                    <input onChange={(val) => this.onChange(val)} value={NoPonsel} name="NoPonsel" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field" style={errorFieldNoPonsel} type="text" placeholder="085794189491" />
                    
                    { // modified by alfan for validator
                      (errorNoPonsel) ? <p className="custom-error-field">
                      {(this.state.errorValidator_step_1.errorNoPonselMessage !== null) ? this.state.errorValidator_step_1.errorNoPonselMessage : 'Nomor ponsel tidak boleh kosong'}</p> : ''}

                    <label className="custom-label"><b>Alamat</b></label>
                    <textarea onChange={(val) => this.onChange(val)} value={Alamat} name="Alamat" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field" style={errorFieldAlamat} type="textarea" rows="5" cols="50"/>
                    
                    {(errorAlamat) ? <p className="custom-error-field">Alamat tidak boleh kosong</p> : ''}

                    </div>
                  </form>
                </div>
                <div className="col-xs-12 col-md-2 col-lg-2"/>
                <div className="col-xs-12 col-md-4 col-lg-4 hidden-xs hidden-line">
                  <div className="aside" style={{borderLeft: '1px solid #FFB200', marginTop: '100px', paddingLeft: '50px', fontSize: '10px', color: '#9DA0A3', lineHeight: '200%'}}>Email, nomor ponsel dan alamat sangat diperlukan karena BPJS membutuhkan data kependudukan anda.</div>
                </div>
              </div>
          </div>
        );
      case 1:
        return (
          <div className="container" style={{marginTop: '10%', marginBottom: '150px'}} id="content content-step-2">
              <div className="row year-section" >
              <Modal
                {...this.props}
                show={this.state.show}
                onHide={() => this.hideModal()}
                dialogClassName="custom-modal"
                bsSize="large"
              >
                <Modal.Header closeButton style={{borderBottom: 'none', marginBottom: '-25px'}}></Modal.Header>
                <Modal.Body>
                  {this.modalContent()}
                </Modal.Body>

              </Modal>
                <div className="col-xs-12 col-md-6 col-lg-6">
                  <div style={{display:'flex', flexDirection: 'row', marginBottom: '35px'}}>
                    <h2><b className="custom-data-title">Dimanakah anda bekerja?</b></h2>
                  </div>
                  <form>
                    <div>
                    <div style={{display:'flex', flexDirection: 'row', marginBottom: '10px'}}>
                      <h4>
                        <b className="custom-data-title">Detail pekerjaan</b>
                        <span style={{marginLeft: '10px', color: '#FFB200'}} className="hidden-sm hidden-md hidden-lg">
                          <i className="fa fa-question-circle w3-tooltip" aria-hidden="true"><span style={{position:'absolute',left:'0',top:'18px', padding: '10px', fontSize: '14px', width:'200px'}} className="w3-text w3-tag tag-detail-pekerjaan">Dengan mengisi informasi tentang pekerjaan anda, maka kami dapat menghitung jumlah asuran si yang dapat anda bayarkan dengan mempertimbangkan data pekerjaan anda.</span></i>
                        </span>
                      </h4>
                    </div>

                    <ProvinsiDropdown errorProvinsi={errorProvinsi} onDropdownChange={this.onDropdownChange} select={Provinsi}/>
                    {
                      // add error message by alfan
                      (errorProvinsi) ? <p className="custom-error-field">Provinsi tidak boleh kosong</p> : ''
                    }

                    <KotaDropdown errorKota={errorKota} onDropdownChange={this.onDropdownChange} kodeLokasi={this.state.data_step_2.Provinsi} select={Kota}/>
                    {
                      // add error message kota by alfan
                      (errorKota) ? <p className="custom-error-field">Kota tidak boleh kosong </p> : ''
                    }

                    <KantorCabangDropdown errorCabang={errorCabang} onDropdownChange={this.onDropdownChange} kodeLokasi={this.state.data_step_2.Kota} kodeProvinsi={this.state.data_step_2.Provinsi} kodeCabang={this.state.data_step_2.Cabang}/>
                    {
                      // add error message kantor cabang by alfan 
                      (errorCabang) ? <p className="custom-error-field"> Kantor cabang BPJS tidak boleh kosong </p> : ''
                    }

                    <label className="custom-label"><b>Jenis pekerjaan anda</b></label>
                    <input onChange={(val) => this.onChange(val)} value={Pekerjaan} name="Pekerjaan" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field" type="text" placeholder="Desainer, Developer, Ilustrator" style={errorFieldPekerjaan}/>
                    
                    { // modified by alfan for validator
                      (errorPekerjaan) ? <p className="custom-error-field">
                        {(this.state.errorValidator_step_2.errorPekerjaanMessage !== null) ? this.state.errorValidator_step_2.errorPekerjaanMessage : 'Pekerjaan tidak boleh kosong '}</p> : ''}

                    <label className="custom-label"><b>Gaji bulanan</b></label>
                    <div className="custom-input-group w3-border-light-gray w3-margin-top w3-margin-bottom custom-field">
                      <div className="custom-input-group-icon" style={errorFieldGaji}>IDR</div>
                      <div className="custom-input-group-area" style={errorFieldGaji}>
                        <input onChange={(val) => this.onChange(val)} value={Gaji} name="Gaji" className="custom-field" type="text" style={{borderRadius: '2px' }} placeholder="3000000"/>
                      </div>
                    </div>
                    
                    { // modified by alfan for validator
                      (errorGaji) ? <p className="custom-error-field">
                        {(this.state.errorValidator_step_2.errorGajiMessage !== null) ? this.state.errorValidator_step_2.errorGajiMessage : 'Gaji Tidak boleh kosong'}</p> : ''}


                    <div className="w3-row">
                      <div className="w3-col s5 w3-margin-bottom" style={{width: '45%'}}>
                        <label className="custom-label"><b>Jam masuk kantor</b></label>
                        <select onChange={(val) => {this.setState({data_step_2: {...data_step_2, JamMasukKantor: val.target.value}}); localStorage.setItem('JamMasukKantor', val.target.value); this.errorHandler('JamMasukKantor', val.target.value)}} name="JamMasukKantor" className="w3-select w3-margin-top w3-margin-bottom custom-field" name="option" placeholder="09:00" style={errorFieldJamMasukKantor}>
                          <option value=""> -- : --</option>
                          { hour().map(h => (<option value={h.value}>{h.text}</option>)) }
                        </select>
                      </div>
                      <div className="w3-col s1 w3-margin-bottom" style={{display:'flex', justifyContent: 'center', alignItems:'center', marginTop: '40px', fontSize: '10px'}}>
                        <p style={{marginTop: '10px'}}>s/d</p>
                      </div>
                      <div className="w3-col s5 w3-margin-bottom" style={{width: '45%'}}>
                        <label className="custom-label"><b>Jam keluar kantor</b></label>
                        <select onChange={(val) => { this.setState({ data_step_2: { ...data_step_2, JamKeluarKantor: val.target.value } }); localStorage.setItem('JamKeluarKantor', val.target.value); this.errorHandler('JamKeluarKantor', val.target.value)}} name="JamKeluarKantor" className="w3-select w3-margin-top w3-margin-bottom custom-field" name="option" placeholder="09:00" style={errorFieldJamKeluarKantor}>
                          <option value=""> -- : --</option>
                          { hour().map(h => (<option value={h.value}>{h.text}</option>)) }
                        </select>
                      </div>
                    </div>
                    
                    {(errorJamMasukKantor || errorJamKeluarKantor) ? <p className="custom-error-field">Jam masuk & keluar kantor tidak boleh kosong</p> : ''}
                    
                    {(errorJamKantor) ? <p className="custom-error-field">{this.state.errorValidator_step_2.errorJamKantorMessage}</p> : ''}

                    <div style={{display:'flex', flexDirection: 'row', marginBottom: '10px'}}>
                      <h6>
                        <b className="custom-data-title">Detail asuransi</b>
                        <span style={{marginLeft: '10px', color: '#FFB200'}} className="hidden-sm hidden-md hidden-lg">
                          <i className="fa fa-question-circle w3-tooltip" aria-hidden="true"><span style={{position:'absolute',left:'0',bottom:'18px', padding: '10px', width: '200px'}} className="w3-text w3-tag">JHT	: Jaminan Hari Tua<br/>JKK	: Jaminan Kecelakaan Kerja<br/>JKM	: Jaminan kematian<br/><b style={{color: '#4A90E2', cursor: 'pointer'}} onClick={() => this.showModal()}>Pelajari lebih lanjut</b></span></i>
                        </span>
                      </h6>
                    </div>

                    <label className="custom-label"><b>Pilih program</b></label>
                    <div style={{display: 'flex', flexDirection: 'row', marginTop: '10px', marginBottom: '20px'}}>

                      <input className="w3-input w3-check custom-field" ref="JHT" type="checkbox" id="JHT" onChange={(val) => {this.setState({data_step_2: {...data_step_2, Program: val.target.id}}); program.push(val.target.id);localStorage.setItem('JHT', val.target.checked);}} value={Program} name="Program"/>
                      <label className="custom-checkbox">JHT</label>

                      <input className="w3-input w3-check custom-field" checked disabled="true" ref="JKK" type="checkbox" id="JKK" onChange={(val) => {this.setState({data_step_2: {...data_step_2, Program: val.target.id}}); program.push(val.target.id)}} value={Program} name="Program" style={{marginLeft: '30px'}}/>
                      <label className="custom-checkbox">JKK</label>

                      <input className="w3-input w3-check custom-field" checked disabled="true" ref="JKM" type="checkbox" id="JKM" onChange={(val) => {this.setState({data_step_2: {...data_step_2, Program: val.target.id}}); program.push(val.target.id)}} value={Program} name="Program" style={{marginLeft: '30px'}}/>
                      <label className="custom-checkbox">JKM</label>

                    </div>
                    {(errorProgram) ? <p className="custom-error-field">Program tidak boleh kosong</p> : ''}

                    <label className="custom-label">
                      <b>Periode program</b>
                      <span style={{ marginLeft: '10px', color: '#FFB200' }} className="hidden-sm hidden-md hidden-lg">
                        <i className="fa fa-question-circle w3-tooltip" aria-hidden="true"><span style={{ position: 'absolute', left: '0', bottom: '18px', padding: '10px', width: '200px' }} className="w3-text w3-tag">Iuran akan dihitung jika anda sudah melengkapi informasi yang dibutuhkan seperti NIK, Gaji, Priode Program dan Kota tempat anda bekerja.</span></i>
                      </span>
                    </label>
                    <div style={{display: 'flex', flexDirection: 'row'}}>
                    <select onChange={(val) => {this.setState({data_step_2: {...data_step_2, PeriodeProgram: val.target.value}}); localStorage.setItem('PeriodeProgram', val.target.value); this.errorHandler('PeriodeProgram', val.target.value)}} name="PeriodeProgram" className="w3-select w3-margin-top w3-margin-bottom custom-field" name="option" placeholder="09:00" style={errorFieldPeriodeProgram} value={PeriodeProgram}>
                      <option value="">-- Pilih --</option>
                      <option value="1">1 Bulan</option>
                      <option value="3" style={{padding: '5px'}}>3 Bulan</option>
                      <option value="6">6 Bulan</option>
                      <option value="12">12 Bulan</option>
                    </select>
                      <button onClick={(e) => this.showIuran(e)} className="w3-white w3-margin-top w3-text-blue w3-block button-hitung-iuran" style={{width: '180px', height: '40px', marginTop: '10px', marginLeft:'4px',	border: '0.5px solid #D3D5D6', background: '#FFF'}}>HITUNG IURAN</button>
                    </div>
                    {(errorPeriodeProgram) ? <p className="custom-error-field">Periode program tidak boleh kosong</p> : ''}

                    <div className="custom-rincian-program" style={{fontSize: '12px', marginBottom: '20px', display: this.state.tampilkanPerhitunganIuran}}>
                      <table>
                        <tr>
                          <td style={{ width: '380px' }}>JKK (Jaminan Kecelakaan Kerja)</td>
                          <td>: Rp { this.state.iuran && this.state.iuran.dataIuran.PROG_JKK ? moneyFormat(this.state.iuran.dataIuran.PROG_JKK.split(':')[0]) : 0 }</td>
                        </tr>
                        <tr>
                          <td style={{width: '380px'}}>JHT (Jaminan Hari Tua)</td>
                          <td>: Rp { this.state.iuran && this.state.iuran.dataIuran.PROG_JHT ? moneyFormat(this.state.iuran.dataIuran.PROG_JHT.split(':')[0]) : 0 }</td>
                        </tr>
                        <tr>
                          <td style={{width: '380px'}}>JKM (Jaminan Kematian)</td>
                          <td>: Rp { this.state.iuran && this.state.iuran.dataIuran.PROG_JKM ? moneyFormat(this.state.iuran.dataIuran.PROG_JKM.split(':')[0]) : 0 }</td>
                        </tr>
                      </table>
                      <hr />
                      <table>
                        <tr>
                          <td style={{width: '380px'}}>Total</td>
                          <td>: Rp { this.state.iuran ? moneyFormat(this.state.iuran.dataIuran.TOTAL) : 0 }</td>
                        </tr>
                      </table>
                    </div>

                    <label className="custom-label">
                      <b>Nomor verifikasi SMS</b>
                      <span style={{marginLeft: '10px', color: '#FFB200'}} className="hidden-sm hidden-md hidden-lg">
                        <i className="fa fa-question-circle w3-tooltip" aria-hidden="true"><span style={{position:'absolute',left:'0',bottom:'18px', padding: '10px', width: '200px'}} className="w3-text w3-tag">Kami akan memverifikasi pendaftaran anda melalu SMS dengan mengirimkan kode tersebut.</span></i>
                      </span>
                    </label>
                    <input onChange={(val) => this.onChange(val)} value={NoVerifikasiSMS} name="NoVerifikasiSMS" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field" type="text" placeholder="320017" style={errorFieldNoVerifikasiSMS}/>

                    { // modified by alfan for validator
                      (errorNoVerifikasiSMS) ? <p className="custom-error-field">
                        {(this.state.errorValidator_step_2.errorNoVerifikasiSMSMessage !== null) ? this.state.errorValidator_step_2.errorNoVerifikasiSMSMessage : 'No SMS verifikasi tidak boleh kosong'}</p> : ''}
                        
                    <p className="custom-label"> * jika tidak mendapatkan verifikasi sms masukkan '123456'</p>

                    </div>
                  </form>
                </div>
                <div className="col-xs-12 col-md-2 col-lg-2"/>
                <div className="col-xs-12 col-md-4 col-lg-4 hidden-xs hidden-line">
                  <div className="aside hide-this" style={{borderLeft: '1px solid #FFB200', marginTop: '150px', paddingLeft: '50px', fontSize: '10px', color: '#9DA0A3', lineHeight: '200%'}}>Dengan mengisi informasi tentang pekerjaan anda, maka kami dapat menghitung jumlah asuran si yang dapat anda bayarkan dengan mempertimbangkan data pekerjaan anda.</div>
                  <div className="aside hide-this" style={{borderLeft: '1px solid #FFB200', marginTop: '590px', paddingLeft: '50px', fontSize: '10px', color: '#9DA0A3', lineHeight: '200%'}}>JHT	: Jaminan Hari Tua<br/>JKK	: Jaminan Kecelakaan Kerja<br/>JKM	: Jaminan kematian</div>
                  <div className="aside hide-this" style={{borderLeft: '1px solid #FFB200', marginTop: '10px', paddingLeft: '50px', fontSize: '10px', color: '#9DA0A3', lineHeight: '200%'}}><b style={{color: '#4A90E2', cursor: 'pointer'}} onClick={() => this.showModal()}>Pelajari lebih lanjut</b></div>
                  <div className="aside hide-this" style={{borderLeft: '1px solid #FFB200', marginTop: '115px', paddingLeft: '50px', fontSize: '10px', color: '#9DA0A3', lineHeight: '200%'}}>Kami akan memverifikasi pendaftaran anda melalu SMS dengan mengirimkan kode tersebut.</div>
                </div>
              </div>
          </div>
        );
      case 2:
        return (
          <div className="w3-content w3-padding">
              <div id="id01" className="w3-modal" style={modalPenjelasan}>
                <div className="w3-modal-content w3-animate-top w3-card-4">
                  <div className="w3-container">
                    {this.modalContentAgreement()}
                  </div>
                </div>
              </div>
              <div id="id01" className="w3-modal" style={modalPembayaran}>
                <div className="w3-modal-content w3-animate-top w3-card-4" style={{width: '500px'}}>
                  <div className="w3-container" style={{margin: '10px'}}>
                    {this.state.paymentOptionsStep === true ? this.modalContentPaymentOptions() : this.modalContentPembayaran()}
                  </div>
                </div>
              </div>
              <div className="w3-row">
                <div style={{display:'flex', flexDirection: 'row', marginBottom: '30px', marginTop: '100px'}}>
                  <h1><b style={{letterSpacing: '1px', color: '#4A4A4A', fontWeight: '600'}}>Mohon periksa data Anda sebelum ke pembayaran</b></h1>
                </div>
                <div className="col-xs-12 col-md-8 col-lg-8">
                  <div className="w3-container w3-padding-32" style={{backgroundColor: '#FCFCFD', border: '0.5px solid #E2E4E6'}}>
                    <div className="w3-container w3-padding-16">

                      <div style={{display:'flex', flexDirection: 'row', marginBottom: '10px'}}>
                        <h6><b className="custom-data-title">Data diri</b></h6>
                      </div>

                      <div>
                        <label className="custom-label-field"><b>NIK (Nomor Induk Kependudukan)</b></label>
                          {/* <span>
                            <b className="custom-edit-pointer" onClick={() => { this.setState({ data_diri_style: { ...data_diri_style, NIKLabelShow: 'none', NIKInputShow: 'block' } })}}>Edit</b>
                          </span> */}
                        <div className="w3-margin-bottom" style={{marginTop: '5px', display: NIKLabelShow}}>
                          <label className="custom-label"><b>{localStorage.getItem('NIK')}</b></label>
                        </div>
                        <input onChange={(val) => this.onChange(val)} value={localStorage.getItem('NIK')} name="NIK" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field" type="text" style={{display: NIKInputShow}}/>
                        {(errorNIK) ? <p className="custom-error-field">Nomor Induk Kependudukan tidak boleh kosong</p> : ''}
                      </div>

                      <div>
                        <label className="custom-label-field"><b>Nama lengkap</b></label>
                          {/* <span>
                            <b className="custom-edit-pointer" onClick={() => { this.setState({ data_diri_style: { ...data_diri_style, NamaLabelShow: 'none', NamaInputShow: 'block' } })}}>Edit</b>
                          </span> */}
                        <div className="w3-margin-bottom" style={{marginTop: '5px', display: NamaLabelShow}}>
                          <label className="custom-label"><b>{localStorage.getItem('NamaLengkap')}</b></label>
                        </div>

                        {/* Modified by alfan */}
                        <input onChange={(val) => this.onChange(val)} value={localStorage.getItem('NamaLengkap')} name="NamaLengkap" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field custom-label" type="text" style={{ display: NamaInputShow, ...errorFieldNamaLengkap }} />

                        {
                          // error message for name modified by alfan
                          (errorNamaLengkap) ? <p className="custom-error-field">{this.state.errorValidator.errorNamaLengkapMessage}</p> : ''
                        }

                        {/* <input onChange={(val) => this.onChange(val)} value={localStorage.getItem('NamaLengkap')} name="NamaLengkap" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field" type="text" style={{display: NamaInputShow}}/> */}
                      </div>

                      <div>
                        <label className="custom-label-field"><b>Tanggal lahir</b></label>
                          {/* <span>
                            <b className="custom-edit-pointer" onClick={() => { this.setState({ data_diri_style: { ...data_diri_style, TglLahirLabelShow: 'none', TglLahirInputShow: 'block' } })}}>Edit</b>
                          </span> */}
                        <div className="w3-margin-bottom" style={{marginTop: '5px', display: TglLahirLabelShow}}>
                        <label className="custom-label"><b>{localStorage.getItem('ThnLahir')} - {localStorage.getItem('BlnLahir')} - {localStorage.getItem('TglLahir')}</b></label>
                        </div>
                        <input onChange={(val) => this.onChange(val)} value={localStorage.getItem('ThnLahir')} name="ThnLahir" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field" type="text" style={{display: TglLahirInputShow}}/>
                      </div>

                      <div>
                        <label className="custom-label-field"><b>Email</b></label>
                          <span>
                            <b className="custom-edit-pointer" onClick={() => { this.setState({ data_diri_style: { ...data_diri_style, EmailLabelShow: 'none', EmailInputShow: 'block' } })}}>Edit</b>
                          </span>
                        <div className="w3-margin-bottom" style={{marginTop: '5px', display: EmailLabelShow}}>
                          <label className="custom-label"><b>{localStorage.getItem('Email')}</b></label>
                        </div>

                        <input onChange={(val) => this.onChange(val)} value={localStorage.getItem('Email')} name="Email" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field custom-label" type="text" style={{ display: EmailInputShow, ...errorFieldEmail }} />

                        { // modified by alfan for validator
                          (errorEmail) ? <p className="custom-error-field">
                            {(this.state.errorValidator_step_1.errorEmailMessage !== null) ? this.state.errorValidator_step_1.errorEmailMessage : 'Email Tidak boleh kosong'}</p> : ''}

                        {/* <input onChange={(val) => this.onChange(val)} value={localStorage.getItem('Email')} name="Email" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field" type="text" style={{display: EmailInputShow}}/>
                         */}
                      </div>

                      <div>
                        <label className="custom-label-field"><b>Nomor telfon</b></label>
                          {/* <span>
                            <b className="custom-edit-pointer" onClick={() => { this.setState({ data_diri_style: { ...data_diri_style, NoTlpLabelShow: 'none', NoTlpInputShow: 'block' } })}}>Edit</b>
                          </span> */}
                        <div className="w3-margin-bottom" style={{marginTop: '5px', display: NoTlpLabelShow}}>
                          <label className="custom-label"><b>{localStorage.getItem('NoPonsel')}</b></label>
                        </div>

                        <input onChange={(val) => this.onChange(val)} value={localStorage.getItem('NoPonsel')} name="NoPonsel" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field" style={{ display: NoTlpInputShow }} type="text"/>

                        {
                          (errorNoPonsel) ? <p className="custom-error-field">
                            {(this.state.errorValidator_step_1.errorNoPonselMessage !== null) ? this.state.errorValidator_step_1.errorNoPonselMessage : 'Nomor ponsel tidak boleh kosong'}</p> : ''}

                        {/* <input onChange={(val) => this.onChange(val)} value={localStorage.getItem('NoPonsel')} name="NoPonsel" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field" type="text" style={{display: NoTlpInputShow}}/> */}
                      </div>

                      <div>
                        <label className="custom-label-field"><b>Alamat</b></label>
                          {/* <span>
                            <b className="custom-edit-pointer" onClick={() => { this.setState({ data_diri_style: { ...data_diri_style, AlamatLabelShow: 'none', AlamatInputShow: 'block' } })}}>Edit</b>
                          </span> */}
                        <div className="w3-margin-bottom" style={{marginTop: '5px', display: AlamatLabelShow}}>
                          <label className="custom-label"><b>{localStorage.getItem('Alamat')}</b></label>
                        </div>

                        {/* modified edit */}
                        <textarea onChange={(val) => this.onChange(val)} value={localStorage.getItem('Alamat')} name="Alamat" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field custom-label" style={{ display: AlamatInputShow, ...errorFieldAlamat }} type="textarea" rows="5" cols="50" />

                        {(errorAlamat) ? <p className="custom-error-field">Alamat tidak boleh kosong</p> : ''}


                        {/* <input onChange={(val) => this.onChange(val)} value={localStorage.getItem('Alamat')} name="Alamat" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field" type="text" style={{display: AlamatInputShow}}/> */}
                      </div>
                    </div>
                  </div>

                  <div className="w3-container w3-padding-32" style={{backgroundColor: '#FCFCFD', border: '0.5px solid #E2E4E6', marginTop: '25px'}}>
                    <div className="w3-container w3-padding-16">

                      <div style={{display:'flex', flexDirection: 'row', marginBottom: '10px'}}>
                        <h6><b className="custom-data-title">Detail Pekerjaan</b></h6>
                      </div>

                      <div>
                        <label className="custom-label-field"><b>Provinsi tempat bekerja</b></label>
                          {/* <span>
                            <b className="custom-edit-pointer" onClick={() => { this.setState({ data_diri_style: { ...data_diri_style, ProvinsiLabelShow: 'none', ProvinsiInputShow: 'block' } })}}>Edit</b>
                          </span> */}
                        <div className="w3-margin-bottom" style={{marginTop: '5px', display: ProvinsiLabelShow}}>
                          <label className="custom-label"><b>{localStorage.getItem('namaProvinsi')}</b></label>
                        </div>
                        <input onChange={(val) => this.onChange(val)} value={localStorage.getItem('Provinsi')} name="Provinsi" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field" type="text" style={{display: ProvinsiInputShow}}/>
                      </div>

                      <div>
                        <label className="custom-label-field"><b>Kota tempat bekerja</b></label>
                          {/* <span>
                            <b className="custom-edit-pointer" onClick={() => { this.setState({ data_diri_style: { ...data_diri_style, KotaLabelShow: 'none', KotaInputShow: 'block' } })}}>Edit</b>
                          </span> */}
                        <div className="w3-margin-bottom" style={{marginTop: '5px', display: KotaLabelShow}}>
                          <label className="custom-label"><b>{localStorage.getItem('namaKota')}</b></label>
                        </div>
                        <input onChange={(val) => this.onChange(val)} value={localStorage.getItem('Kota')} name="Kota" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field" type="text" style={{display: KotaInputShow}}/>
                      </div>

                      <div>
                        <label className="custom-label-field"><b>Kantor BPJS terdekat</b></label>
                          {/* <span>
                            <b className="custom-edit-pointer" onClick={() => { this.setState({ data_diri_style: { ...data_diri_style, CabangLabelShow: 'none', CabangInputShow: 'block' } })}}>Edit</b>
                          </span> */}
                        <div className="w3-margin-bottom" style={{marginTop: '5px', display: CabangLabelShow}}>
                          <label className="custom-label"><b>{localStorage.getItem('namaCabang')}</b></label>
                        </div>
                        <input onChange={(val) => this.onChange(val)} value={localStorage.getItem('Cabang')} name="Cabang" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field" type="text" style={{display: CabangInputShow}}/>
                      </div>

                      <div>
                        <label className="custom-label-field"><b>Jenis pekerjaan</b></label>
                          <span>
                            <b className="custom-edit-pointer" onClick={() => { this.setState({ data_diri_style: { ...data_diri_style, PekerjaanLabelShow: 'none', PekerjaanInputShow: 'block' } })}}>Edit</b>
                          </span>
                        <div className="w3-margin-bottom" style={{marginTop: '5px', display: PekerjaanLabelShow}}>
                          <label className="custom-label"><b>{localStorage.getItem('Pekerjaan')}</b></label>
                        </div>

                        {/* Modified edit by alfan */}
                        <input onChange={(val) => this.onChange(val)} value={localStorage.getItem('Pekerjaan')} name="Pekerjaan" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field custom-label" type="text" style={{ display: PekerjaanInputShow, ...errorFieldPekerjaan }} />

                        { // modified by alfan for validator
                          (errorPekerjaan) ? <p className="custom-error-field">
                            {(this.state.errorValidator_step_2.errorPekerjaanMessage !== null) ? this.state.errorValidator_step_2.errorPekerjaanMessage : 'Pekerjaan tidak boleh kosong '}</p> : ''}

                        
                        {/* <input onChange={(val) => this.onChange(val)} value={localStorage.getItem('Pekerjaan')} name="Pekerjaan" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field" type="text" style={{display: PekerjaanInputShow}}/> */}
                      </div>

                      <div>
                        <label className="custom-label-field"><b>Gaji bulanan</b></label>
                          <span>
                            <b className="custom-edit-pointer" onClick={() => { this.setState({ data_diri_style: { ...data_diri_style, GajiLabelShow: 'none', GajiInputShow: 'block' } })}}>Edit</b>
                          </span>
                        <div className="w3-margin-bottom" style={{marginTop: '5px', display: GajiLabelShow}}>
                          <label className="custom-label"><b>IDR {localStorage.getItem('Gaji')}</b></label>
                        </div>
                        {/* Modified edit by alfan */}
                        <input onChange={(val) => this.onChange(val)} value={localStorage.getItem('Gaji')} name="Gaji" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field custom-label" type="text" style={{ display: GajiInputShow, ...errorFieldGaji }} />
                        { // modified by alfan for validator
                          (errorGaji) ? <p className="custom-error-field">
                            {(this.state.errorValidator_step_2.errorGajiMessage !== null) ? this.state.errorValidator_step_2.errorGajiMessage : 'Gaji Tidak boleh kosong'}</p> : ''}

                        {/* <input onChange={(val) => this.onChange(val)} value={localStorage.getItem('Gaji')} name="Gaji" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field" type="text" style={{display: GajiInputShow}}/> */}
                      </div>

                      <div>
                        <label className="custom-label-field"><b>Jam masuk dan keluar kantor</b></label>
                          <span>
                            <b className="custom-edit-pointer" onClick={() => { this.setState({ data_diri_style: { ...data_diri_style, JamMasukKantorLabelShow: 'none', JamMasukKantorInputShow: 'block' } })}}>Edit</b>
                          </span>
                        <div className="w3-margin-bottom" style={{marginTop: '5px', display: JamMasukKantorLabelShow}}>
                        <label className="custom-label"><b>{localStorage.getItem('JamMasukKantor')} - {localStorage.getItem('JamKeluarKantor')}</b></label>
                        </div>

                        {/* Modified edit by alfan */}
                        <div className="w3-row" style={{ display: JamMasukKantorInputShow }}>
                          <div className="w3-col s5 w3-margin-bottom" style={{ width: '45%' }}>
                            <select onChange={(val) => { this.setState({ data_step_2: { ...data_step_2, JamMasukKantor: val.target.value } }); localStorage.setItem('JamMasukKantor', val.target.value); this.errorHandler('JamMasukKantor', val.target.value) }} name="JamMasukKantor" className="w3-select w3-margin-top w3-margin-bottom custom-field custom-label" name="option" placeholder="09:00" style={errorFieldJamMasukKantor} value={localStorage.getItem('JamMasukKantor')}>
                              <option value=""> -- : --</option>
                              {hour().map(h => (<option value={h.value}>{h.text}</option>))}
                            </select>
                          </div>
                          <div className="w3-col s1 w3-margin-bottom" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px', fontSize: '10px' }}>
                            <p style={{ marginTop: '10px' }}>s/d</p>
                          </div>
                          <div className="w3-col s5 w3-margin-bottom" style={{ width: '45%' }}>
                            <select onChange={(val) => { this.setState({ data_step_2: { ...data_step_2, JamKeluarKantor: val.target.value } }); localStorage.setItem('JamKeluarKantor', val.target.value); this.errorHandler('JamKeluarKantor', val.target.value) }} name="JamKeluarKantor" className="w3-select w3-margin-top w3-margin-bottom custom-field custom-label" name="option" placeholder="09:00" style={errorFieldJamKeluarKantor} value={localStorage.getItem('JamKeluarKantor')}>
                              <option value=""> -- : --</option>
                              {hour().map(h => (<option value={h.value}>{h.text}</option>))}
                            </select>
                          </div>
                        </div>
                        <div className="w3-row">
                          {(errorJamKantor) ? <p className="custom-error-field">{this.state.errorValidator_step_2.errorJamKantorMessage}</p> : ''}
                        </div>
                        <div className="w3-row">
                          {(errorJamMasukKantor || errorJamKeluarKantor) ? <p className="custom-error-field">Jam masuk & keluar kantor tidak boleh kosong</p> : ''}
                        </div>
                        {/* <input onChange={(val) => this.onChange(val)} value={localStorage.getItem('JamMasukKantor')} name="JamMasukKantor" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field" type="text" style={{display: JamMasukKantorInputShow}}/> */}
                      </div>
                    </div>
                  </div>

                  <div className="w3-container w3-padding-32" style={{backgroundColor: '#FCFCFD', border: '0.5px solid #E2E4E6', marginTop: '25px', marginBottom: '150px'}}>
                    <div className="w3-container w3-padding-16">

                      <div style={{display:'flex', flexDirection: 'row', marginBottom: '10px'}}>
                        <h6><b className="custom-data-title">Detail asuransi</b></h6>
                      </div>

                      <div>
                        <label className="custom-label-field"><b>Program</b></label>
                        <span>
                          <b className="custom-edit-pointer" onClick={() => { this.setState({data_diri_style: {...data_diri_style, ProgramLabelShow: 'none', ProgramInputShow: 'flex'}})}}>Edit</b>
                        </span>
                        <div className="w3-margin-bottom" style={{marginTop: '5px', display: ProgramLabelShow}}>
                          <label className="custom-label"><b>{(localStorage.getItem('JHT') === 'true') ? 'JHT, ': ''} JKK, JKM</b></label>
                        </div>

                        {/* edit modified by alfan */}
                        <div style={{ display: ProgramInputShow, flexDirection: 'row', marginTop: '10px', marginBottom: '20px' }}>

                          <input className="w3-check-sm custom-field" ref="JHT" type="checkbox" id="JHT" onChange={(val) => { this.setState({ data_step_2: { ...data_step_2, Program: val.target.id } }); program.push(val.target.id); localStorage.setItem('JHT', val.target.checked); }} value={Program} name="Program" checked={localStorage.getItem('JHT') === 'true'}/>
                          <label className="custom-label"> JHT</label>

                          <input className="w3-check-sm custom-field" checked disabled="true" ref="JKK" type="checkbox" id="JKK" name="Program" style={{ marginLeft: '30px' }} />
                          <label className="custom-label" style={{ marginTop: 'auto' }}>JKK</label>

                          <input className="w3-check-sm custom-field" checked disabled="true" ref="JKM" type="checkbox" id="JKM" name="Program" style={{ marginLeft: '30px' }} />
                          <label className="custom-label" style={{ marginTop: 'auto' }}>JKM</label>

                        </div>

                        {/* <input onChange={(val) => this.onChange(val)} value={""} name="NIK" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field" type="text" style={{display: 'none'}}/> */}
                      </div>

                      <div>
                        <label className="custom-label-field"><b>Periode program</b></label>
                          <span>
                            <b className="custom-edit-pointer" onClick={() => { this.setState({ data_diri_style: { ...data_diri_style, PeriodeProgramLabelShow: 'none', PeriodeProgramInputShow: 'flex' } })}}>Edit</b>
                          </span>
                        <div className="w3-margin-bottom" style={{marginTop: '5px', display: PeriodeProgramLabelShow}}>
                          <label className="custom-label"><b>{localStorage.getItem('PeriodeProgram')} Bulan</b></label>
                        </div>

                        {/* edit modified by alfan */}
                        <div style={{ display: PeriodeProgramInputShow, flexDirection: 'row' }}>
                        <select onChange={(val) => { this.setState({ data_step_2: { ...data_step_2, PeriodeProgram: val.target.value } }); localStorage.setItem('PeriodeProgram', val.target.value); this.errorHandler('PeriodeProgram', val.target.value) }} name="PeriodeProgram" className="w3-select w3-margin-top w3-margin-bottom custom-field custom-label" name="option" placeholder="09:00" style={errorFieldPeriodeProgram} value={localStorage.getItem('PeriodeProgram')}>
                            <option value="">-- Pilih Periode Program--</option>
                            <option value="1">1 Bulan</option>
                            <option value="3" style={{ padding: '5px' }}>3 Bulan</option>
                            <option value="6">6 Bulan</option>
                            <option value="12">12 Bulan</option>
                          </select>
                        </div>
                        {(errorPeriodeProgram) ? <p className="custom-error-field">Periode program tidak boleh kosong</p> : ''}
                        
                        {/* <input onChange={(val) => this.onChange(val)} value={localStorage.getItem('PeriodeProgram')} name="PeriodeProgram" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field" type="text" style={{display: PeriodeProgramInputShow}}/> */}
                      </div>

                      <div>
                        <label className="custom-label-field"><b>No verifikasi SMS</b></label>
                          <span>
                            <b className="custom-edit-pointer" onClick={() => { this.setState({ data_diri_style: { ...data_diri_style, NoVerifikasiSMSLabelShow: 'none', NoVerifikasiSMSInputShow: 'block' } })}}>Edit</b>
                          </span>
                        <div className="w3-margin-bottom" style={{marginTop: '5px', display: NoVerifikasiSMSLabelShow}}>
                          <label className="custom-label"><b>{localStorage.getItem('NoVerifikasiSMS')}</b></label>
                        </div>

                        {/* edit modified by alfan */}
                        <input onChange={(val) => this.onChange(val)} value={localStorage.getItem('NoVerifikasiSMS')} name="NoVerifikasiSMS" className="w3-input w3-border-light-gray w3-margin-top w3-margin-bottom custom-field custom-label" type="text" style={{display: NoVerifikasiSMSInputShow, ...errorFieldNoVerifikasiSMS}}/>
                        { // modified by alfan for validator
                          (errorNoVerifikasiSMS) ? <p className="custom-error-field">
                            {(this.state.errorValidator_step_2.errorNoVerifikasiSMSMessage !== null) ? this.state.errorValidator_step_2.errorNoVerifikasiSMSMessage : 'No SMS verifikasi tidak boleh kosong'}</p> : ''}

                      </div>

                    </div>
                  </div>

                </div>
                <div className="col-xs-12 col-md-4 col-lg-4 hidden-xs">
                  <div className="w3-container w3-padding-32 custom-content-hidden">
                    <div className="w3-container w3-padding-16" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                      <p style={{fontSize: '16px', marginTop: '-20px', marginBottom: '20px',letterSpacing: '1px', fontWeight: 'bold', color: '#4A4A4A'}}>Daftar sekarang dalam 3 cara mudah..</p>
                    </div>
                    <div className="w3-container w3-padding-16">
                      <form>
                        <label className="custom-label"><b>NIK (Nomor Induk Kependudukan)</b></label>
                        <label className="custom-label"><b>Nama Lengkap</b></label>
                        <label className="custom-label"><b>Tanggal Lahir</b></label>
                        <div className="w3-row" style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                          <div className="w3-col l4 m4 w3-margin-bottom" style={{width: '110px'}}>
                            <select className="w3-select w3-margin-top custom-field" name="option">
                              <option value="1990">1990</option>
                              <option value="1991">1991</option>
                              <option value="1992">1992</option>
                            </select>
                          </div>
                          <div className="w3-col l4 m4 w3-margin-bottom" style={{width: '110px'}}>
                            <select className="w3-select w3-margin-top custom-field" name="option">
                              <option value="Januari">Januari</option>
                              <option value="Februari">Februari</option>
                              <option value="Maret">Maret</option>
                            </select>
                          </div>
                          <div className="w3-col l4 m4 w3-margin-bottom" style={{width: '110px'}}>
                            <select className="w3-select w3-margin-top custom-field" name="option">
                              <option value="01">01</option>
                              <option value="02">02</option>
                              <option value="03">03</option>
                            </select>
                          </div>
                        </div>
                      </form>
                    </div>
                    <div className="w3-container w3-padding-16" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    </div>
                    <div className="w3-container w3-padding-16" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#B7BCBF', fontSize: '10px'}}>
                      <i className="fa fa-lock" aria-hidden="true"></i><p style={{marginLeft: '10px'}}>Informasi Anda tersimpan aman</p>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        );
      default:
        return '';
    }
  }

  render() {
    const {stepIndex} = this.state;

    const contentStyle = {margin: '0 16px'};
    let stepHistory;
    if (localStorage.getItem('step_status') !== null) {
      stepHistory = Number(localStorage.getItem('step_status'));
    }else {
      stepHistory = stepIndex;
    }
    return(
      <div>
        <Loading isLoading={this.state.loading} />
      <p>{this.getStepContent(stepHistory)}</p>
      <div className="w3-row">
        <div className="w3-show">
          <footer className="w3-container w3-cell-bottom custom-footer" style={{position: 'fixed', bottom: '0px', left: '0px', width: '100%', borderTop: 'solid 1px #E2E2E2', height: (this.state.formError !== '') ? '130px':'100px'}}>
            <MuiThemeProvider muiTheme={getMuiTheme(citilinkTheme)}>
              <div style={{width: '100%', maxWidth: 900, margin: 'auto'}} className="w3-margin-top">
                <Stepper style={{color: '#C3C3C3'}} linear={false} activeStep={stepIndex} connector={<i className="fa fa-long-arrow-right hidden-xs" aria-hidden="true"></i>}>
                  <Step className="hidden-xs">
                    <StepButton onClick={() => this.setState({stepIndex: stepHistory})}>
                      <StepLabel
                        style={(this.state.formError.step === 0)? {color: red500} : ''}
                      >Data diri</StepLabel>
                    </StepButton>
                  </Step>
                  <Step className="hidden-xs">
                    <StepButton onClick={() => this.setState({stepIndex: stepHistory})}>
                      <StepLabel
                        icon={<WarningIcon color={red500} />}
                        style={(this.state.formError.step === 1)? {color: red500} : ''}
                      >Data pekerjaan</StepLabel>
                    </StepButton>
                  </Step>
                  <Step className="hidden-xs">
                    <StepButton onClick={() => this.setState({stepIndex: stepHistory})}>
                      <StepLabel
                        style={(this.state.formError.step === 2)? {color: red500} : ''}
                      >Konfirmasi pembayaran</StepLabel>
                    </StepButton>
                  </Step>
                  <div className="w3-container btn-step" style={{width: '250px', textAlign: 'center'}}>
                      <button id={`lanjut-step-${stepIndex}`} className="w3-btn w3-blue w3-block" onClick={this.handleNext}>{(stepIndex === 2) ? 'PROSES' : 'LANJUT'}</button>
                  </div>
                </Stepper>
                <div style={{height: '100px'}}><span style={{color: red500}}>{(this.state.formError !== '') ? this.state.formError.msg : ''}</span></div>
              </div>
            </MuiThemeProvider>
          </footer>
        </div>
      </div>

      </div>
    )
  }
}

export default withRouter(Content);



// WEBPACK FOOTER //
// ./src/component/Step/Content/index.js